exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1x7xU {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  outline: none; }\n\n.sort---11pKc {\n  width: 10px;\n  height: 30px;\n  margin-left: auto;\n  outline: none; }\n\n.title---2GAFk {\n  display: inline-block; }\n\n.sort---11pKc::before {\n  font-family: icomoon;\n  content: \"\\E902\"; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1x7xU",
	"sort": "sort---11pKc",
	"title": "title---2GAFk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/formatters/header-formatter/index.scss
// module id = 1162
// module chunks = 3